<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="批量修改"
      class="replacementBill-edit"
      width="1200px"
      top="2vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="repairRegistrationVo"
        :rules="ruleValidate"
        class="form"
        label-width="120px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户名称">
            <el-input v-model="repairRegistrationVo.customerName" readonly placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectCustomer.open()">
                选择
              </el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="终端客户">
            <el-input v-model="repairRegistrationVo.terminalCustomerName"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否保修">
            <el-radio-group v-model="repairRegistrationVo.isWarranty">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户地址">
            <el-input v-model="repairRegistrationVo.customerAddress" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="送修单位">
            <el-input v-model="repairRegistrationVo.fixUnitName" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结款方式">
            <el-select v-model="repairRegistrationVo.paymentMethod" clearable placeholder="请选择状态">
              <el-option label="款到发货" value="款到发货"/>
              <el-option label="月结" value="月结"/>
              <el-option label="季度结" value="季度结"/>
              <el-option label="年结" value="年结"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="收货人">
            <el-input v-model="repairRegistrationVo.consignee"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收货人电话">
            <el-input v-model="repairRegistrationVo.consigneeContact"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="返厂快递单号">
            <el-input v-model="repairRegistrationVo.returnCourierNO"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="快递单位">
            <el-input v-model="repairRegistrationVo.deliverWay"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发运快递单号">
            <el-input v-model="repairRegistrationVo.deliverCourierNO"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="3个月内维修次数">
            <el-input v-model="repairRegistrationVo.frequency" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发运时间">
            <el-date-picker
                v-model="repairRegistrationVo.deliverTime"
                style="width: 190px"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收费金额">
            <el-input v-model="repairRegistrationVo.chargedAmount" :disabled="!repairRegistrationVo.isCharge"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否已质检:">
            <el-radio-group v-model="repairRegistrationVo.isInspection">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="质检结果:">
            <el-radio-group v-model="repairRegistrationVo.inspectionResult">
              <el-radio :label="true">ok</el-radio>
              <el-radio :label="false">ng</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  export default {
    name: "BatchUpdate",
    components: { CustomerSelect},
    data() {
      return {
        dialogVisible: false,
        uploadLoading: false,
        contentLoading: false,
        submitLoading: false,
        imgUrls: [],
        repairRegistrationVo: {
          pkid: "",
          ids: [],
          billNo: "",
          type: 20,
          receiveTime: "",
          batchQuantity: "",
          productBarCode: "",
          accomplishCodeDesc: "",
          processInCode: "",
          accomplishCode: "",
          nodeCode: "",
          creatTime: "",
          receiveName: "",
          barcode: "",
          materialId: "",
          materialNo: "",
          materialName: "",
          customerAddress: "",
          customerName: "",
          returnCourierNO: "",
          deliverCourierNO: "",
          attachments: [],
          isWarranty: true,
          isCharge: true,
          hardwareVersion: "",
          softwareVersion: "",
          historicalAlarms: "",
          faultReporting: "",
          faultActual: "",
          faultTime: "",
          maintenanceRecord: "",
          repairId: "",
          repairName: "",
          replacementParts: "",
          note: "",
          status: "",
          repairTime: "",
          chargedAmount: "",
          workerNo: "",
          frequency: "",
          faultType: "",
          stopServiceTime: "",
          oldDeliveryBillNo: "",
          specification: "",
          saleMonth: "",
          deliverTime: "",
          deliverWay: "",
          consigneeContact: "",
          consignee: "",
          terminalCustomerName: "",
          fixUnitName: "",
          paymentMethod: "",
          details: [],
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空", trigger: "blur"},
          orderReturnReasonName: {required: true, message: "退货原因不能为空", trigger: "blur"},
          typeName: {required: true, message: "退货类型不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        console.log(row);
        this.dialogVisible = true;
        if (row) {
          this.repairRegistrationVo.ids = row;
        }
      },
      selectMaterial(row) {
        this.repairRegistrationVo.materialId = row.id;
        this.repairRegistrationVo.materialNo = row.no;
        this.repairRegistrationVo.materialName = row.name;
        this.repairRegistrationVo.specification = row.zmyxh;
      },
      selectCustomer(row) {
        this.repairRegistrationVo.customerName = row.customerName;
        this.repairRegistrationVo.customerId = row.customerID;
        if (row.customerDeliveryAddresses) {
          this.repairRegistrationVo.customerAddress = row.customerDeliveryAddresses;

        }
      },
      selectCustomer2(row) {
        this.repairRegistrationVo.terminalCustomerName = row.customerName;
        this.repairRegistrationVo.terminalCustomerId = row.customerID;
        this.repairRegistrationVo.customerAddress = row.customerDeliveryAddresses;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "repairRegistrations/batchUpdate", this.repairRegistrationVo)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  top: 15% !important;
  left: 0 !important;
}
</style>